// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"132":"forms","138":"profile","225":"rooms","796":"tables","966":"login"}[chunkId] || chunkId) + "." + {"132":"cb0ab890","138":"babc1c85","225":"cc566d9c","631":"dc68ec69","796":"1e52195d","966":"6303490a"}[chunkId] + ".js";
};